__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "console";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@betsterz/event-bus", "1.0.0", () => (__webpack_require__.e(523).then(() => (() => (__webpack_require__(8523))))));
			register("@geneui/components", "3.0.0-next-00c811a-04052026", () => (Promise.all([__webpack_require__.e(143), __webpack_require__.e(871), __webpack_require__.e(862)]).then(() => (() => (__webpack_require__(7143))))));
			register("@geneui/icons", "1.4.10", () => (Promise.all([__webpack_require__.e(756), __webpack_require__.e(862)]).then(() => (() => (__webpack_require__(5756))))));
			register("i18next-browser-languagedetector", "7.2.2", () => (__webpack_require__.e(298).then(() => (() => (__webpack_require__(5298))))));
			register("i18next-resources-to-backend", "1.2.4", () => (__webpack_require__.e(87).then(() => (() => (__webpack_require__(9087))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(303).then(() => (() => (__webpack_require__(9303))))));
			register("react-dom", "19.3.1", () => (Promise.all([__webpack_require__.e(862), __webpack_require__.e(322)]).then(() => (() => (__webpack_require__(3322))))));
			register("react-i18next", "13.5.0", () => (Promise.all([__webpack_require__.e(602), __webpack_require__.e(862)]).then(() => (() => (__webpack_require__(6602))))));
			register("react-router-dom", "7.18.5", () => (Promise.all([__webpack_require__.e(860), __webpack_require__.e(871), __webpack_require__.e(862)]).then(() => (() => (__webpack_require__(5860))))));
			register("react", "19.3.1", () => (__webpack_require__.e(394).then(() => (() => (__webpack_require__(4394))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};